import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Products from '@/views/Products.vue'
import Partners from '@/views/Partners.vue'
import About from '@/views/About.vue'
import Cases from '@/views/Cases.vue'
import AIDigitalHuman from '@/views/AIDigitalHuman.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '首页 - 雪顶科技'
    }
  },
  {
    path: '/products',
    name: 'Products',
    component: Products,
    meta: {
      title: '产品中心 - 雪顶科技'
    }
  },
  {
    path: '/ai-digital-human',
    name: 'AIDigitalHuman',
    component: AIDigitalHuman,
    meta: {
      title: 'AI数字人 - 雪顶科技'
    }
  },
  {
    path: '/cases',
    name: 'Cases',
    component: Cases,
    meta: {
      title: '客户案例 - 雪顶科技'
    }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
    meta: {
      title: '渠道合作 - 雪顶科技'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: '关于我们 - 雪顶科技'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '雪顶科技'
  next()
})

export default router 